import React from "react";
import { Address as AddressType } from "../../../State/customer/addressSlice";

interface UserAddressCardProps {
    addressItem: AddressType;
}

const UserAddressCard = ({ addressItem }: UserAddressCardProps) => {
    return (
        <div className='p-5 border rounded-md flex flex-col justify-between'>
            <div className='space-y-3'>
                <h1 className="font-semibold text-lg">{addressItem.name}</h1>
                <p className='w-[320px] text-gray-600'>
                    {addressItem.address}, {addressItem.locality}, {addressItem.city}, {addressItem.state} - {addressItem.pinCode}
                </p>
                <p>
                    <strong>Mobile No: </strong>{addressItem.mobile}
                </p>
            </div>
        </div>
    );
};

export default UserAddressCard;